import { $window, $body } from '../../../Constants';
import HtmlElement from '../../../Elements/HtmlElement';

/**
 * Shortcuts
 */
const Shortcuts = (() => {
  // Constants
  const DATA_KEY = 'ig.cta-bar';
  const EVENT_KEY = `.${DATA_KEY}`;

  /**
   * Selector
   *
   * @var { Object }
   */
  const Selector = {
    SHORTCUTS: '.tx-ig-shortcuts',
  };

  /**
   * Event
   *
   * @var { Object }
   */
  const Event = {
    RESIZE: `resize${EVENT_KEY}`
  };

  /**
   * Shortcuts
   *
   * @class
   * @augments HtmlElement
   */
  class Shortcuts extends HtmlElement {
    // Public

    /**
     * Handles ready event
     *
     * @return void
     */
    onReady() {
      this._prevHeight = 0;
      this._bindHandlers();
      this._adjustBodyPadding();
    }

    // Private

    /**
     * Binds the event handlers to the elements
     *
     * @return void
     */
    _bindHandlers() {
      $window.on(Event.RESIZE, () => {
        if (this.getHeight() !== this._prevHeight) {
          this._adjustBodyPadding();
        }
      });
    }

    /**
     * Adjusts the body padding to reserve a space for the shortcuts
     *
     * @return void
     */
    _adjustBodyPadding() {
      if (this.$element.hasClass('display-type-1') || this.$element.hasClass('display-type-2')) {
		  if ($window.width() < 640) {
			  $body.css('padding-bottom', this.getHeight());
			  this._prevHeight = this.getHeight();
		  } else {
			  $body.css('padding-bottom', 0);
			  this._prevHeight = 0;
		  }
	  } else {
		  $body.css('padding-bottom', this.getHeight());
		  this._prevHeight = this.getHeight();
	  }
    }
  }

  return Shortcuts._getElement($body.find(Selector.SHORTCUTS), Shortcuts);
})();

export default Shortcuts;
